/**
 * Uma tarefa que o agente acompanha em segundo plano e responde na conversa quando termina
 * (AB#86889). Espelha o `BackgroundTaskView` da api.
 */
export interface BackgroundTask {
  id: string;
  /** O identificador curto que o agente mostra ("a1b2c3d4"). */
  short_id: string;
  chat_id: string;
  kind: string;
  target_id: string;
  /** O que foi pedido, resumido. */
  request: string | null;
  status: "watching" | "completing" | "delivered" | "failed_delivery" | "cancelled" | "expired";
  outcome: "succeeded" | "failed" | "cancelled" | "expired" | null;
  created_at: string;
  completed_at: string | null;
  expires_at: string;
}

/** Uma tarefa ainda viva — a que conta no indicador. */
export function isRunningTask(task: Pick<BackgroundTask, "status">): boolean {
  return task.status === "watching" || task.status === "completing";
}

/**
 * Aviso na janela de que alguma tarefa mudou. O Playground o dispara ao receber a mudança pela
 * sala SSE; a marca do Chat no menu lateral o escuta para reler na hora, sem abrir outra conexão.
 */
export const BACKGROUND_TASKS_CHANGED_EVENT = "prodgy:background-tasks-changed";

/** Uma conversa com algo acontecendo — o agente respondendo e/ou tarefas vivas (AB#86889). */
export interface ChatActivity {
  chat_id: string;
  turn_running: boolean;
  background_tasks: number;
}
